import {html} from 'lit';

export const facet3Template = () => html`
    <div class="image-facet image-facet-3-md">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 360 270" style="enable-background:new 0 0 360 270;" xml:space="preserve">
            <polygon class="fill-blue" points="360,267.5 211.6,181.8 360,96.1 360,93.8 207.6,181.8 360,269.8 "/>
        </svg>
    </div>

    <div class="image-facet image-facet-3-lg">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 731 537" xml:space="preserve">
            <g>
                <g>
                    <path class="fill-blue" d="M538.5,326.3l174.9,100.7L538.5,527.8L363.6,427.1L538.5,326.3 M538.5,324.2l-178.6,103L538.5,530
                    l178.6-102.9L538.5,324.2L538.5,324.2z"/>
                </g>
                <path class="fill-violet" d="M71.9,146.7l126.5-73l-44.3-25.5c-11.7-6.8-26.2-6.8-37.9,0L90.9,62.8c-11.7,6.8-19,19.3-19,32.8V146.7z"/>
                <path class="fill-yellow400" d="M71.8,280.6L71.8,280.6l0.1-133.9l0,0l-58,33.4v67L71.8,280.6z"/>
            </g>
        </svg>
    </div>
`;